import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import Routes from '@/router/Routes';

interface ProtectedAdminRouteProps extends PropsWithChildren {
  requireSuperAdmin?: boolean;
}

const ProtectedAdminRoute: FC<ProtectedAdminRouteProps> = ({ children, requireSuperAdmin = false }) => {
  const { isAdmin, isSuperAdmin, loading } = useAdminAuth();

  // Show loading state while checking permissions
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="loading loading-spinner loading-lg"></div>
      </div>
    );
  }

  // Check if user has required permissions
  const hasAccess = requireSuperAdmin ? isSuperAdmin : isAdmin;

  if (!hasAccess) {
    // Redirect to dashboard if not authorized
    return <Navigate to={Routes.DASHBOARD} replace />;
  }

  return <>{children}</>;
};

export default ProtectedAdminRoute;
